// src/components/Screenshots/Screenshots.js
import React from 'react';
import './ScreenshotsMultiplayer.css';

// Import images
import screenshot1 from '../../assets/screenshot07.jpg';
import screenshot2 from '../../assets/screenshot08.jpg';
import screenshot3 from '../../assets/screenshot09.jpg';
import screenshot4 from '../../assets/screenshot010.jpg';
import screenshot5 from '../../assets/screenshot014.jpg';
import screenshot6 from '../../assets/screenshot013.jpg';


const screenshots = [
  screenshot1,
  screenshot2,
  screenshot3,
  screenshot4,
  screenshot5,
  screenshot6,
];

const ScreenshotsMultiplayer = () => {
  return (
    <div className="screenshots-container">
      {screenshots.map((src, index) => (
        <div className="screenshot-item" key={index}>
          <img src={src} alt={`Screenshot ${index + 1}`} />
        </div>
      ))}
    </div>
  );
};

export default ScreenshotsMultiplayer;
